<template lang="pug">

  transition(name="fade")
    #login
      No Access

</template>

<script>
  
import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'

export default {

  name: 'login',
  
  components: {},
  
  data() {
    return {}
  },
  
  computed: {
    ...mapState('app', ['loading'])
  },
  
  mounted() { 
  },
  
  beforeDestroy() {},
  
  methods: { 
  },
  
  watch: { 
    'loading.completed'(val){
      if(val){ 
      }
    }
  }

}

</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"

#login
  +full()

  ul
    height: 100%;
    position: absolute;

    li
      height: 25vh;
      width: 100vw;
      +flex-center();

      p
        font-size: 1.4rem;
        line-height: 1.8; 
        text-align: center;
        background-color: #f8f8f8;
        padding: 0 2rem;



</style> 



